import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BackgroundBeams } from '@/components/ui/background-beams';
import type { AboutSectionData } from '@/sanity/types';

interface AboutHeroSectionProps {
  data?: AboutSectionData | undefined;
}

/**
 * R2 - Hero section for About Us page
 * R4 - Accepts optional Sanity data, falls back to hardcoded defaults
 */
export function AboutHeroSection({ data }: AboutHeroSectionProps) {
  const badge = data?.heroBadge ?? 'Conoce nuestra historia';
  const title = data?.heroTitle ?? 'Sobre';
  const description = data?.heroDescription ?? 'Desde 2014, transformando espacios con soluciones modulares de calidad, eficiencia y compromiso con cada cliente.';
  return (
    <section className="py-14 sm:py-16 bg-slate-50 relative overflow-hidden">
      <BackgroundBeams />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-inboca-teal hover:text-inboca-teal/80 font-medium mb-8 transition-colors animate-fade-in-up"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al Inicio
        </Link>

        <div className="text-center max-w-4xl mx-auto animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-inboca-teal/10 rounded-full text-inboca-teal font-semibold text-sm mb-6">
            {badge}
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {title} <span className="text-inboca-teal">Nosotros</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}
